import { createListenerMiddleware } from '@reduxjs/toolkit';
import { constant, createListenerEffect } from '@socialive/common';
import { migrate } from '~/store/env/thunks';

const legacyDomain = Object.entries({
  'portal.socialive.us': /app.socialive.us/,
  'staging-portal.socialive.us': /sbx.socialive.cloud/,
  localhost: /localhost/,
})
  .filter(() => window.location.pathname !== '/migration.html')
  .find(([, current]) => current.test(window.location.hostname))
  ?.shift();

export const effect = createListenerEffect(
  'portal/env/migrate<Listener>',
  async (action, { dispatch, getState, unsubscribe, trigger }) => {
    unsubscribe();

    if (legacyDomain) {
      const iframe = document.createElement('iframe');
      iframe.src = `${window.location.origin.replace(window.location.hostname, legacyDomain)}/migration.html`;
      iframe.hidden = 'hidden';

      const onMessage = async (event) => {
        if (event?.data?.type === 'migration') {
          const { storage } = event.data.payload;
          await dispatch(
            migrate({
              storage,
              trigger,
            })
          );
          iframe.remove();
          window.removeEventListener('message', onMessage);
        }
      };

      window.addEventListener('message', onMessage);

      document.body.appendChild(iframe);
    }
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  matcher: constant(true),
  effect,
});

export default middleware;
